export function getAll() {
  return [
    {
      value: 0,
      name: "Unsend",
      text: "未寄送",
    },
    {
      value: 1,
      name: "Sending",
      text: "傳輸中",
    },
    {
      value: 2,
      name: "Failed",
      text: "失敗",
    },
    {
      value: 3,
      name: "Success",
      text: "成功",
    },
    {
      value: 4,
      name: "Rejected",
      text: "拒絕",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
